import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { getUser } from '../../actions/session';
import { INVOICE_EMAIL_HISTORY_API, GET_ALL_ACCOUNTS } from '../../config/rest_endpoints';
import CustomLoader from '../common/loader';
import { Notifications } from '../common/notification';
import { fmtDollar4 } from '../common/formatters';
import { withRouter } from 'react-router';
import Select from 'react-select';
import Pagination from 'react-js-pagination';
import moment from 'moment';

const STATUS_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Sent', value: 'sent' },
    { label: 'Failed', value: 'failed' },
]

const InvoiceEmailHistory = (props) => {
    const [userInfo] = useState(getUser())
    const [logs, setLogs] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [activePage, setActivePage] = useState(1)
    const [itemCounts, setItemCounts] = useState({ label: '25', value: 25 })
    const [accountOption, setAccountOption] = useState([])
    const [accountFilter, setAccountFilter] = useState(null)
    const [statusFilter, setStatusFilter] = useState(STATUS_OPTIONS[0])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [isBtnSpin, setIsBtnSpin] = useState(false)
    const [searchNonce, setSearchNonce] = useState(0)

    const countList = [
        { label: '10', value: 10 },
        { label: '25', value: 25 },
        { label: '50', value: 50 },
        { label: '100', value: 100 },
    ]

    useEffect(() => {
        fetchAccounts()
    }, [])

    useEffect(() => {
        fetchHistory()
    }, [activePage, itemCounts, searchNonce])

    const fetchAccounts = () => {
        const headers = { Authorization: 'Bearer ' + userInfo.token }
        Axios.get(GET_ALL_ACCOUNTS, { headers }).then(res => {
            if (res && res.data && res.data.data) {
                const options = res.data.data.map(a => ({ label: a.accountName, value: a.id }))
                setAccountOption(options)
            }
        }).catch(() => {})
    }

    const sortNewestFirst = (items) => {
        return (items || []).slice().sort((a, b) => {
            const aTime = new Date(a.sentAt || a.createdAt || 0).getTime()
            const bTime = new Date(b.sentAt || b.createdAt || 0).getTime()
            return bTime - aTime
        })
    }

    const fetchHistory = () => {
        const headers = { Authorization: 'Bearer ' + userInfo.token }
        const params = new URLSearchParams({
            page: activePage,
            limit: itemCounts.value,
            sortBy: 'sentAt',
            sortOrder: 'desc',
            sort: 'sentAt',
            order: 'desc',
        })
        if (accountFilter && accountFilter.value) params.set('accountID', accountFilter.value)
        if (statusFilter && statusFilter.value) params.set('status', statusFilter.value)
        if (startDate) params.set('startDate', moment(startDate).format('MM/DD/YYYY, h:mm:ss A'))
        if (endDate) params.set('endDate', moment(endDate).format('MM/DD/YYYY, h:mm:ss A'))

        setIsLoading(true)
        setIsBtnSpin(true)
        Axios.get(`${INVOICE_EMAIL_HISTORY_API}?${params.toString()}`, { headers })
            .then(res => {
                setIsLoading(false)
                setIsBtnSpin(false)
                if (res && res.data) {
                    setLogs(sortNewestFirst(res.data.data))
                    setTotalCount(res.data.pageinfo ? res.data.pageinfo.totalCount : (res.data.totalCount || 0))
                }
            })
            .catch(err => {
                setIsLoading(false)
                setIsBtnSpin(false)
                const msg = err.response && err.response.data && err.response.data.message
                    ? err.response.data.message : 'Failed to load email history'
                Notifications.notify(msg, 'Error', 'error')
            })
    }

    const handleDate = (date, value) => {
        if (!date) {
            if (value === 'start') setStartDate(null)
            else setEndDate(null)
            return
        }
        if (value === 'start') {
            setStartDate(moment(date).startOf('day').toDate())
        } else {
            setEndDate(moment(date).endOf('day').toDate())
        }
    }

    const handleSearch = () => {
        if (activePage === 1) {
            setSearchNonce(value => value + 1)
        } else {
            setActivePage(1)
        }
    }

    const handleClearDates = () => {
        setStartDate(null)
        setEndDate(null)
        if (activePage === 1) {
            setSearchNonce(value => value + 1)
        } else {
            setActivePage(1)
        }
    }

    const handleSelectPagination = (value) => {
        setItemCounts(value)
        setActivePage(1)
    }

    const formatDate = (dateStr) => {
        if (!dateStr) return '—'
        const d = new Date(dateStr)
        return d.toLocaleString('en-US', {
            year: 'numeric', month: 'short', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
        })
    }

    const StatusBadge = ({ status }) => {
        const isSent = status === 'sent'
        return (
            <span style={{
                display: 'inline-flex', alignItems: 'center', gap: '4px',
                padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: '600',
                background: isSent ? '#ECFDF5' : '#FEF2F2',
                color: isSent ? '#047857' : '#B91C1C',
                border: `1px solid ${isSent ? '#A7F3D0' : '#FECACA'}`,
            }}>
                <span style={{
                    width: '6px', height: '6px', borderRadius: '50%',
                    background: isSent ? '#10B981' : '#EF4444',
                    display: 'inline-block'
                }}></span>
                {isSent ? 'Sent' : 'Failed'}
            </span>
        )
    }

    return (
        <div>
            <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                {/* Header */}
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                    <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                        <i className="icon-envelop" style={{color:'#475569',fontSize:'14px'}}></i>
                        <h5 style={{fontWeight:'600',fontSize:'14px',color:'#0F172A',margin:0}}>Email Send History</h5>
                    </div>
                    <div style={{width:'9em'}}>
                        <Select
                            value={itemCounts}
                            onChange={handleSelectPagination}
                            options={countList}
                            placeholder="Per page"
                        />
                    </div>
                </div>

                {/* Filters */}
                <div style={{background:'#F8FAFC',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                    <div style={{display:'flex',flexWrap:'wrap',gap:'16px',alignItems:'flex-end'}}>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>From Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDate ? moment(startDate).format('YYYY-MM-DD') : ''}
                                max={endDate ? moment(endDate).format('YYYY-MM-DD') : undefined}
                                onChange={event => handleDate(event.target.value, 'start')}
                                style={{minWidth:'180px',borderRadius:'8px',border:'1px solid #E2E8F0',fontSize:'13px',background:'#fff'}}
                            />
                        </div>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>To Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDate ? moment(endDate).format('YYYY-MM-DD') : ''}
                                min={startDate ? moment(startDate).format('YYYY-MM-DD') : undefined}
                                onChange={event => handleDate(event.target.value, 'end')}
                                style={{minWidth:'180px',borderRadius:'8px',border:'1px solid #E2E8F0',fontSize:'13px',background:'#fff'}}
                            />
                        </div>
                        {(startDate || endDate) && (
                            <button
                                type="button"
                                onClick={handleClearDates}
                                style={{background:'#fff',color:'#475569',border:'1px solid #CBD5E1',borderRadius:'10px',padding:'8px 14px',fontSize:'13px',fontWeight:'500',cursor:'pointer'}}
                            >
                                Clear Dates
                            </button>
                        )}
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>Account</label>
                            <div style={{minWidth:'220px'}}>
                                <Select
                                    value={accountFilter}
                                    onChange={v => setAccountFilter(v)}
                                    options={accountOption}
                                    isClearable
                                    placeholder="All Accounts"
                                />
                            </div>
                        </div>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>Status</label>
                            <div style={{minWidth:'140px'}}>
                                <Select
                                    value={statusFilter}
                                    onChange={v => setStatusFilter(v)}
                                    options={STATUS_OPTIONS}
                                    placeholder="All"
                                />
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={handleSearch}
                            style={{background:'linear-gradient(135deg,#10B981,#059669)',color:'#fff',border:'none',borderRadius:'10px',padding:'8px 20px',fontSize:'13px',fontWeight:'500',cursor:'pointer',boxShadow:'0 2px 8px rgba(16,185,129,0.25)',marginLeft:'auto'}}
                        >
                            Search <i className={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-arrow-right8'} ml-2`}></i>
                        </button>
                    </div>
                </div>

                {/* Table */}
                <div style={{overflowX:'auto',overflowY:'auto',maxHeight:'56em'}}>
                    <table className="table table-striped" style={{margin:0}}>
                        <thead>
                            <tr>
                                <th>Date Sent</th>
                                <th>Account</th>
                                <th>Sent To</th>
                                <th>Invoice #</th>
                                <th>Billing Period</th>
                                <th style={{textAlign:'right'}}>Amount</th>
                                <th style={{textAlign:'center'}}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <CustomLoader />
                            ) : logs.length === 0 ? (
                                <tr><td colSpan="7" style={{textAlign:'center',padding:'32px',color:'#94A3B8',fontSize:'13px'}}>No email history found</td></tr>
                            ) : logs.map((log, idx) => (
                                <tr key={idx}>
                                    <td style={{whiteSpace:'nowrap',fontSize:'12px'}}>{formatDate(log.sentAt)}</td>
                                    <td style={{fontWeight:'500'}}>{log.accountName}</td>
                                    <td style={{color:'#1D4ED8',fontSize:'12px'}}>{log.sentTo}</td>
                                    <td style={{fontFamily:'monospace',fontSize:'12px'}}>{log.invoiceNumber}</td>
                                    <td style={{fontSize:'12px'}}>{log.dateRange}</td>
                                    <td style={{textAlign:'right',fontWeight:'600'}}>{fmtDollar4(log.totalAmount)}</td>
                                    <td style={{textAlign:'center'}}>
                                        <StatusBadge status={log.status} />
                                        {log.status === 'failed' && log.errorMessage && (
                                            <div title={log.errorMessage} style={{fontSize:'10px',color:'#B91C1C',marginTop:'2px',maxWidth:'160px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                                                {log.errorMessage}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div style={{padding:'12px 20px',borderTop:'1px solid #F1F5F9',textAlign:'center'}}>
                    <Pagination
                        activePage={activePage}
                        itemsCountPerPage={itemCounts.value}
                        totalItemsCount={totalCount}
                        pageRangeDisplayed={5}
                        onChange={p => setActivePage(p)}
                    />
                </div>
            </div>
        </div>
    )
}

export default withRouter(InvoiceEmailHistory)
